<template>
  <div class="theatre">
    <div class="theatre-seats" v-show="$store.state.pageLoaded">
      <div class="theatre-seats-holder">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-30 -30 595 473" preserveAspectRatio="xMidYMid meet">
          <Row v-for="(row, rowID) in $store.state.theatre.rows" :model="{id: rowID, row: row}" :disabled="false"/>
          <g class="row-numbers">
            <text v-for="label in $store.state.labels[$store.state.currentStageKind]" :x="label.x" :y="label.y" :style="label.style">{{ label.value }}</text>
          </g>
        </svg>
      </div>
    </div>
    <TheatreLegend/>
  </div>
</template>

<script>
export default {
  name: 'AdminTheatre',
}
</script>

<style lang="scss">
.theatre-seats{
  width: calc(100% - 400px);
  border: 0;
}

.scan-true > circle{
  stroke: #34a853;
  stroke-width: 4.5!important;
  paint-order: stroke;
  r: 3;
}

.row-numbers text{
  font-size: 8px;
  transform: translateY(-1px);
  font-weight: bold;
}

.theatre-container{
  position: relative;
  .back-button{
    position: absolute;
    top: 0;
    left: -25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminTheatre.vue